export default class BaseCache {
  static initCache() {
    this.cache = {};
  }

  static addToCache(key, object) {
    if (this.cache === undefined) {
      this.initCache();
    }

    this.cache[key.toLowerCase()] = object;
    //console.log("cache", this.cache)
  }

  static retrieveFromCache(key) {
    //console.log('retrieve from cache', key)
    if (this.cache === undefined) {
      this.initCache();
    }
    return this.cache[key] !== undefined ? this.cache[key] : null;
  }
}
